import { type FastAddDialogSettingsType } from 'app/main/modules/components/FastAddDialog';
import { DescriptionSection, InlineTitle } from 'app/main/modules/components/FastAddDialogSettingsManager';

import LeaveDetailsSectionInfo from './details/sections/LeaveDetailsSectionInfo';

import LeaveEvents from './LeaveEvents';
import LeaveDetailsSectionSecondaryInfo from './details/sections/LeaveDetailsSectionSecondaryInfo';
import DetailsSectionNotes from 'app/main/submodules/notes/DetailsSectionNotes';

export default {
	content: props => (
		<>
			<InlineTitle text="DETAILS_INFO_SECTION" />
			<LeaveDetailsSectionInfo {...props} />
			<InlineTitle text="DETAILS_DESCRIPTION_SECTION" />
			<DescriptionSection
				name="leav_descriptionhtml"
				value={props.model.leav_descriptionhtml}
				isEdit={props.isEdit}
				sendChange={props.sendChange}
			/>
			<InlineTitle text="DETAILS_SECONDARY_INFO_SECTION" />
			<LeaveDetailsSectionSecondaryInfo {...props} />
			<DetailsSectionNotes module="leave" uid={props.model.leav_uid} />
		</>
	),
	events: LeaveEvents,
	showOpenFullDetails: true
} as FastAddDialogSettingsType;
